<template>
  <div id="container">
    <div class="error-box">
      <div class="error-in">
        <div class="text-wrap">
          <p class="tit">{{ $t(messageProperty) }}</p>
          <p class="txt">
            {{ $t('sdl.gcrm.common.apologize.info1') }}
            <br />
            {{ $t('sdl.gcrm.common.apologize.info2') }}
            <br />
            <span v-if="errorCode === '201'">보안서약서 에러 발생.</span>
            <span v-else-if="errorCode === '404'">{{ $t('sdl.gcrm.common.notFound.page') }}</span>
            <span v-else>{{ errPack[errorCode] ? $t(errPack[errorCode]) : '' }}</span>
          </p>
        </div>
        <div class="btn-wrap">
          <span v-if="errorCode !== '410'">
          <button class="btn btn-secondary btn-lg" type="button" @click="goMain">{{ $t('sdl.gcrm.common.go.main') }}</button>
          <button class="btn btn-secondary btn-lg" type="button" @click="goBack">{{ $t('sdl.gcrm.common.go.prev') }}</button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SDLUtil from '@/utils/SDLUtil';
import SDLLocale from '@/mixin/SDLLocale';
import loginService from '@/service/loginService';

export default {
  mixins: [SDLLocale],
  data() {
    return {
      messageProperty: '', // 페이지 사과문 큰 제목
      routeUrl: '/',
      errorCode: '404',
      errPack: {
        185: 'sdl.auth.message.user.notFound',
        187: 'sdl.auth.message.token.retentionTimeout',
        188: 'sdl.login.noUserInfoByIdEmail',
        190: 'sdl.auth.message.user.notFound',
        191: 'sdl.auth.message.user.waiting',
        192: 'sdl.auth.message.user.inactive',
        193: 'sdl.auth.message.user.deleted',
        194: 'sdl.auth.message.token.invalid',
        195: 'sdl.auth.message.token.notFound',
        199: 'sdl.auth.message.duplicate.login',
        200: 'sdl.auth.message.access.limit.exceeded',
        201: 'sdl.gcrm.voc.authreq.security.agree',
        202: 'sdl.common.message.knoxLoginFail',
        203: 'sdl.auth.message.user.exceed.password',
        404: 'sdl.gcrm.common.apologize.info2',
        410: '',
        9999: 'sdl.auth.message.access.denied',
      },
    };
  },
  created() {
    this.messageProperty = this.$route.path.includes('404') ? 'sdl.gcrm.common.notFound.page' : 'sdl.gcrm.common.apologize';
    this.errorCode = this.$route.query.code || '404';
    if(this.errorCode === '410')
    {
      this.messageProperty = 'sdl.gcrm.main.notallow-mobile';
    }
    if (this.$route.path.includes('/noauth')) {
      this.errorCode = 9999;
      this.routeUrl = `${SDLUtil.WEB_CONTEXT_PATH}/`;
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (['187', '194', '195', '199', '200', '202', '203'].includes(String(this.errorCode))) {
        // localStorage.setItem('userToken', '');
        loginService.logout();
      }
      if (['194', '195'].includes(String(this.errorCode))) {
        this.routeUrl = `${SDLUtil.WEB_CONTEXT_PATH}/login`;
        this.$router.replace({ path: this.routeUrl }).catch(() => {});
      }
    });
  },
  methods: {
    goMain() {
      if (this.errPack[this.errorCode]) {
        const redirect = this.$route.query.redirect || '';
        if (['187', '194', '195', '199', '200', '202', '203'].includes(String(this.$route.query.code))) {
          if (redirect) {
            this.routeUrl = `${SDLUtil.WEB_CONTEXT_PATH}/login?redirect=${redirect}`;
          } else {
            this.routeUrl = `${SDLUtil.WEB_CONTEXT_PATH}/login`;
          }
        }
      }
      if (this.$route.path.includes('/noauth')) {
        this.errorCode = 9999;
        this.routeUrl = `${SDLUtil.WEB_CONTEXT_PATH}/`;
      }
      this.$router.replace({ path: this.routeUrl }).catch(() => {});
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
@import 'static/css/css.scss';
</style>



// WEBPACK FOOTER //
// src/components/view/admin/main/EmptyPage.vue